<template>
  <div>
    <h5 class="text-center text-color-red" v-show="allow_above_medication_text">
      {{ translatedFields['above_please_tell_us_more_about_yourself'] }}
    </h5>
    <h5 class="text-center">
      {{ translatedFields['please_tell_us_more_about_yourself'] }}
    </h5>
    <!-- first name / last name-->
    <div class="row">
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['first_name'] }}
          </label>
          <input class="form-control"
                 type="text"
                 data-vv-as="First Name"
                 name="firstName"
                 v-validate="modelValidations.firstName"
                 v-model="model.firstName"
                 placeholder="ex: Mike"
          />
          <small class="text-danger" v-show="firstName.invalid">
            {{ getError('firstName', 'First') }}
          </small>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['last_name'] }}
          </label>
          <input class="form-control"
                 type="text"
                 data-vv-as="Last Name"
                 name="lastName"
                 v-validate="modelValidations.lastName"
                 v-model="model.lastName"
                 placeholder="ex: Andrew"
          />
          <small class="text-danger" v-show="lastName.invalid">
            {{ getError('lastName') }}
          </small>
        </div>
      </div>
    </div>
    
    <!-- dob and date added-->
    <div class="row">
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['date_of_birth'] }}
          </label>
          <input class="form-control date-cleave-format"
                 type="text"
                 name="dob_pretty"
                 v-model="model.dob_pretty"
                 v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                 @change="validateDate($event.target.value)"
                 placeholder="ex: 12/22/1980"
                 maxlength="10"
          />
          <small class="text-danger" v-if="errorDate" v-text="errorDate">
            {{ errorDate }}
          </small>
        </div>
      </div>
      <div class="col-md-5">
         <div class="form-group">
          <label class="control-label required">
            {{ translatedFields['date_of_service'] }}
          </label>
          <input class="form-control dateService-cleave-format"
                 type="text"
                 name="do_service_pretty"
                 v-model="model.do_service_pretty"
                 v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                 @change="validateDateService($event.target.value)"
                 placeholder="ex: 12/22/1988"
                 maxlength="10"
                 
          />
          <small class="text-danger" v-if="errorDateService" v-text="errorDateService">
            {{ errorDateService }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
        <div class="col-md-10 col-md-offset-1">
          <div class="form-group">
            <small class="text-danger" v-show="errorData" v-html="errorData"></small>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {DatePicker, Autocomplete, Drawer, Button, Dialog} from 'element-ui'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import axios from 'axios'
  import Cleave from 'cleave.js'
  require('cleave.js/dist/addons/cleave-phone.us')
//  PATIENT NAME
//  PATIENT ADDRESS
//  PATIENT DOB
//  PATIENT PHONE NUMBER
//  PATIENT EMAIL ADDRESS
//  PATIENT INSURANCE DETAILS
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Autocomplete.name]: Autocomplete,
      [Drawer.name]: Drawer,
      [Button.name]: Button,
      [Dialog.name]: Dialog
    },
    mixins: [FormatterUtils, ValidationUtils],
    data () {
      return {
        errorData: '',
        drawerDisclaimer: false,
        drawer: false,
        double_entry_email: process.env.DOUBLE_ENTRY_EMAIL,
        suggestions: [],
        smartystreets_key: process.env.SMARTYSTREETS_KEY,
        apply_cdc_question_formatter: String(process.env.APPLY_CDC_QUESTION_FORMATTER) === 'true',
        symptomatic_question_name: process.env.SYMPTOMATIC_QUESTION_NAME || 'Symptomatic',
        symptomatic_onset_question_name: process.env.SYMPTOMATIC_ONSET_QUESTION_NAME || 'Symptom Onset',
        answers_es: {},
        answers_zh: {},
        errorDate: '',
        errorDateService: '',
        questionErrorDate: [],
        questionErrorDateService: [],
        answer_no: 'No',
        isEmailForTesting: false,
        allow_above_medication_text: String(process.env.ALLOW_ABOVE_MEDICATION_TEXT) === 'true',
        fields_en: {
          first_name: 'First Name',
          last_name: 'Last Name',
          date_of_birth: 'Date Of Birth',
          date_of_service: 'Date of Service',
          above_please_tell_us_more_about_yourself: 'The new Federal Mandate for Covid Testing requires ALL patient info to be accurate. Incorrect patient info may delay results or result in the sample being rejected.',
          please_tell_us_more_about_yourself: 'Please tell us more about yourself',
          answer_required: 'Answer required'
        },
        translatedFields: '',
        model: {
          firstName: '',
          lastName: '',
          dob: '',
          dob_pretty: '',
          do_service: '',
          do_service_pretty: ''
        },
        modelValidations: {
          firstName: {
            min: 2,
            required: true
          },
          lastName: {
            min: 2,
            required: true
          }
          // dob: {
          //   required: true,
          //   date_format: ' este mm-dd-yyyy',
          //   // eslint-disable-next-line
          //   regex: /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/
          // }
        }
      }
    },
    methods: {
      openDisclaimer () {
        this.drawerDisclaimer = true
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async validate () {
        this.$store.state.matchUser.firstName = ''
        this.$store.state.matchUser.lastName = ''
        this.$store.state.matchUser.dob = ''
        this.$store.state.matchUser.email = ''
        this.$store.state.matchUser.address = ''
        this.$store.state.matchUser.gender = ''
        this.$store.state.matchUser.race = ''
        this.$store.state.matchUser.ethnicity = ''
        this.$store.state.matchUser.phone = ''
        this.$store.state.matchUser.isCompleted = ''
        this.$store.state.matchUser.confirmation_number = ''
        this.$store.state.matchUser.patientid = ''
        this.$store.state.matchUser.result = ''
        if (!this.model.dob) {
          this.errorDate = 'Date Of Birth field is required'
        } else if (this.isFutureDate(this.model.dob_pretty)) {
          this.errorDate = 'Date Of Birth should not be in the future'
        } else if (!this.errorDate.includes('must be valid')) {
          this.errorDate = ''
        }
        if (!this.model.do_service) {
          this.errorDateService = 'Date Of Service field is required'
        } else if (this.isFutureDate(this.model.do_service_pretty)) {
          this.errorDateService = 'Date Of Service should not be in the future'
        } else if (!this.errorDateService.includes('must be valid')) {
          this.errorDateService = ''
        }
        if ((await this.$validator.validateAll() === true) && this.errorDate === '') {
          return new Promise((resolve, reject) => {
            let sitecode = this.$store.state.site.code
            axios.post(process.env.SERVER_URI + '/patient_match/' + sitecode, this.model).then(async (response) => {
              if (response.data === false) {
                this.errorData = 'Invalid Data!'
                reject(new Error('Invalid Data!'))
              } else {
                this.errorData = ''
                this.$store.state.matchUser.firstName = response.data[0].first_name
                this.$store.state.matchUser.lastName = response.data[0].last_name
                this.$store.state.matchUser.dob = response.data[0].date_of_birth
                this.$store.state.matchUser.email = response.data[0].email
                this.$store.state.matchUser.address = response.data[0].address
                this.$store.state.matchUser.gender = response.data[0].gender_id
                this.$store.state.matchUser.race = response.data[0].race_id
                this.$store.state.matchUser.ethnicity = response.data[0].ethnicity_id
                this.$store.state.matchUser.phone = response.data[0].phone
                this.$store.state.matchUser.isCompleted = response.data[0].completed
                this.$store.state.matchUser.confirmation_number = response.data[0].name
                this.$store.state.matchUser.patientid = response.data[0].id
                if (response.data[0].completed === '1') {
                  this.$store.state.matchUser.result = response.data[0].result
                  this.$emit('jumpToTheFourthPage')
                }
              }
              resolve(true)
            }).catch(() => {
              this.errorData = 'Invalid Data or server issues!'
              reject(new Error('Invalid Data or server issues!'))
            })
          })
        }
      },
      translateToSpanish (option) {
        if (this.$store.state.lang.value === 'ES' && this.answers_es) {
          return this.answers_es[option]
        } else {
          if (this.$store.state.lang.value === 'ZH' && this.answers_zh) {
            return this.answers_zh[option]
          } else {
            return option
          }
        }
      },
      checkLanguage () {
        if (this.$store.state.lang.value === 'ES') {
          this.translatedFields = this.$store.state.translation_es
        } else {
          if (this.$store.state.lang.value === 'ZH') {
            this.translatedFields = this.$store.state.translation_zh
          } else {
            this.translatedFields = this.fields_en
          }
        }
      }
    },
    computed: {
      language () {
        this.checkLanguage()
        return this.$store.state.lang.value
      },
      spanishFields () {
        return this.$store.state.translation_es
      },
      chineseFields () {
        return this.$store.state.translation_zh
      },
      ...mapFields(['firstName', 'lastName', 'email', 'address', 'gender', 'dob', 'do_service'])
    },
    watch: {
      language () {
        this.checkLanguage()
      },
      'model.dob_pretty': {
        handler: function (dobValue) {
          let dateCleave = new Cleave('.date-cleave-format', {
            date: true,
            delimiter: '/',
            datePattern: ['m', 'd', 'Y']
          })
          this.model.dob_pretty = dateCleave.getFormattedValue()
          if (dobValue.length === 10) {
            let dateParts = dobValue.split('/')
            this.model.dob = dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1]
          }
        },
        deep: true
      },
      'model.do_service_pretty': {
        handler: function (doServiceValue) {
          let dateCleave = new Cleave('.dateService-cleave-format', {
            date: true,
            delimiter: '/',
            datePattern: ['m', 'd', 'Y']
          })
          this.model.do_service_pretty = dateCleave.getFormattedValue()
          if (doServiceValue.length === 10) {
            let dateParts = doServiceValue.split('/')
            this.model.do_service = dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1]
          }
        },
        deep: true
      }
    }
  }
</script>
<style scoped>

 >>> .el-select--large{
      width: 100%;
    }

 >>> .el-autocomplete{
      width: 100%;
    }

  .required:after {
    content:" *";
    color: red;
  }

  h5{
    margin-bottom: 25px;
  }

  .display-none {
    display: none;
  }

  .text-color-red {
    color: red;
  }

  .htrx-primary{
    color: #f4c617;
  }

  .generic-answer {
    margin-top: 10px;
  }

  .w-100{
    width: 100%;
  }

  .scan-button{
    font-size: 17px;
    color: #f4c617;
    background: white;
    border: 1px solid #f4c617;
    border-radius: 5px;
  }

  .underline{
    text-decoration: underline;
  }

  .d-flex{
    display: flex;
  }

  .checkbox{
    margin-top: 0;
  }

  .c-pointer{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PatientMatch/Wizard/PatientMatchRegistration.vue